/** @format */

import appConfig from "../configs/app.config";
import { REDIRECT_URL_KEY } from "../constant/app.constant";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAppSelector } from "../store/hook";
import * as RoleSelector from "src/store/role/selector";

const { unAuthenticatedEntryPath } = appConfig;

const ProtectedRoute = () => {
  // const { authenticated } = useAuth();
  const location = useLocation();
  const role = useAppSelector(RoleSelector.selectUserRole);
  const redirectUrl = "/";

  if (role != "employer") {
    if (role == "user") {
      return <Outlet />;
    }
    return (
      <Navigate
        replace
        to={`${unAuthenticatedEntryPath}?${redirectUrl}=${location.pathname}`}
      />
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
